import React, { Component } from 'react'
import { navigateTo } from 'gatsby-link'
import MailchimpSubscribe from './MailchimpSubscribe'

const url =
  'https://keepaustinaffordable.us19.list-manage.com/subscribe/post?u=ca7f4fe2e5eae30cc8bc21a43&amp;id=4fc75ae140'

import 'bootstrap/dist/css/bootstrap.css'
import './MailchimpForm.css'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

const CustomForm = ({ status, message, onValidated }) => {
  let email, lname, fname, supporter, volunteer
  const submit = () =>
    email &&
    fname &&
    lname &&
    supporter &&
    volunteer &&
    email.value.indexOf('@') > -1 &&
    onValidated({
      EMAIL: email.value,
      FNAME: fname.value,
      LNAME: lname.value,
      SUPPORTER: supporter.value,
      VOLUNTEER: volunteer.value,
    })

  return (
    <div className="form-group row p-3 p-md-4 container MailchimpForm form-inline">
      <h5 className="col-12 mb-3">Get our latest updates</h5>
      {status === 'sending' && <div style={{ color: 'blue' }}>sending...</div>}
      {status === 'error' && (
        <div
          style={{ color: 'red' }}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      {status === 'success' && (
        <div
          style={{ color: 'white' }}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      <input
        ref={node => (email = node)}
        type="email"
        placeholder="Email"
        className="form-control form-control-lg col-12 mb-2"
      />
      <br />
      <input
        ref={node => (fname = node)}
        type="text"
        placeholder="First Name"
        className="form-control form-control-lg col-12 mb-2"
      />
      <br />
      <input
        ref={node => (lname = node)}
        type="text"
        placeholder="Last Name"
        className="form-control form-control-lg col-12 mb-2"
      />
      <br />
      <select
        className="custom-select mb-2 col-12 form-control form-control-md"
        name="publicSupport"
        ref={node => (supporter = node)}
        defaultValue={0}
      >
        <option value="No Answer">Show me as a public supporter?</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
      </select>
      <select
        className="custom-select mb-2 col-12 form-control form-control-md"
        name="volunteer"
        ref={node => (volunteer = node)}
        defaultValue={0}
      >
        <option value="No Answer">Want to volunteer?</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
      </select>
      <button onClick={submit} className="col-12 mb-2 btn btn-info btn-lg">
        Submit
      </button>
    </div>
  )
}

class MailchimpForm extends Component {
  render() {
    return (
      <MailchimpSubscribe
        url={url}
        render={({ subscribe, status, message }) => (
          <CustomForm
            status={status}
            message={message}
            onValidated={formData => subscribe(formData)}
          />
        )}
      />
    )
  }
}

export default MailchimpForm



// WEBPACK FOOTER //
// ./src/components/MailchimpForm.js